import { useEffect } from 'react';
import { fg, featureGateKeys } from '@app/feature-gates';
import { useOneTrustContext } from '@app/onetrust';
import { pruneReadIds } from '../storage/localStorage';

/**
 * Trigger a one-time, self-throttled prune of the stored read set on app mount.
 *
 * Prune is self-contained (it reads dates from its own storage), so this hook
 * needs no data — it only decides WHETHER to run. We gate on the unread
 * indicator feature flag and analytics consent, matching the rest of the
 * feature. pruneReadIds() additionally no-ops if it already ran today.
 */
export const useUnreadPrune = (): void => {
  const { analyticsOptOut } = useOneTrustContext();
  const isEnabled = fg(featureGateKeys.gaReleaseChanges) && !analyticsOptOut;

  useEffect(() => {
    if (!isEnabled) {
      return;
    }

    pruneReadIds();
  }, [isEnabled]);
};
